import React from 'react'
import { Block, CRIcon, Inline } from '../crRender'
import "./style.css"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
const NoExist = ({ isExist }) => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <Block isRender={isExist} className={"w-100 item-screen"}>
            <CRIcon icon={"tdesign:search-error"} className={"full-screen-icon"} />
            <Block>{t("no-data")} <Inline className={"cta-click"} onClick={() => navigate(-1)}>{t("click-to-go-back")}</Inline></Block>
        </Block>
    )
}

export default NoExist